import { App, defineAsyncComponent } from 'vue'

import RatingStars from './RatingStars.vue'

const Gallery = defineAsyncComponent(() => import('./Gallery.vue'))
const FacilityMap = defineAsyncComponent(() => import('./Map.vue'))
const DoctorCatalog = defineAsyncComponent(() => import('./DoctorCatalog.vue'))
const ServicesCatalog = defineAsyncComponent(() => import('./ServicesCatalog.vue'))
const Contacts = defineAsyncComponent(() => import('./Contacts.vue'))
const Scheduler = defineAsyncComponent(() => import('./Scheduler.vue'))
const Tabs = defineAsyncComponent(() => import('./Tabs.vue'))
const Catalog = defineAsyncComponent(() => import('./Catalog.vue'))
const ReviewCatalog = defineAsyncComponent(() => import('./ReviewCatalog.vue'))
const PreviewMap = defineAsyncComponent(() => import('./PreviewMap.vue'))
const NetworkCatalog = defineAsyncComponent(() => import('./NetworkCatalog.vue'))
const NetworkMap = defineAsyncComponent(() => import('./NetworkMap.vue'))

const install = (app: App<Element>, prefix = 'Facility'): void => {
  app
    .component(`${prefix}Gallery`, Gallery)
    .component(`${prefix}Map`, FacilityMap)
    .component(`${prefix}DoctorCatalog`, DoctorCatalog)
    .component(`${prefix}ServicesCatalog`, ServicesCatalog)
    .component(`${prefix}Scheduler`, Scheduler)
    .component(`${prefix}Contacts`, Contacts)
    .component(`${prefix}Tabs`, Tabs)
    .component(`${prefix}Catalog`, Catalog)
    .component(`${prefix}ReviewCatalog`, ReviewCatalog)
    .component(`${prefix}RatingStars`, RatingStars)
    .component(`${prefix}PreviewMap`, PreviewMap)
    .component(`${prefix}NetworkCatalog`, NetworkCatalog)
    .component(`${prefix}NetworkMap`, NetworkMap)
}

export default {
  install,
}
